import React, { useEffect, useState } from 'react';
import { getActivity } from '../api';

export default function Activity() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { getActivity(100).then(setLogs); }, []);
  return (
    <>
      <div className="page-header"><div><h1>Activity Log</h1><p>Full history of all actions</p></div></div>
      <div className="page-content">
        <div className="card">
          <table className="tbl">
            <thead><tr><th>Time</th><th>Action</th><th>Site</th><th>Details</th><th>Result</th></tr></thead>
            <tbody>
              {!logs.length&&<tr><td colSpan={5} style={{textAlign:'center',padding:24,color:'var(--text3)'}}>No activity yet</td></tr>}
              {logs.map(l=>(
                <tr key={l.id}>
                  <td style={{color:'var(--text3)',fontSize:11,whiteSpace:'nowrap'}}>{new Date(l.created_at).toLocaleString()}</td>
                  <td className="bold">{l.action.replace(/_/g,' ')}</td>
                  <td style={{color:'var(--text3)',fontSize:11}}>{l.site_name||'—'}</td>
                  <td style={{fontSize:11,maxWidth:240,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{l.details}</td>
                  <td><span className={`badge ${l.result==='success'?'green':l.result==='error'?'red':'amber'}`}>{l.result}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
